import axios from "../utils/axios";

function request(url, method = "get", data = {}, headers = {}) {
  return axios({
    url,
    method,
    data,
    headers
  });
}
function get(url, data = {}, headers = {}) {
  return request(url, "get", data, headers);
}

function post(url, data = {}, headers = {}) {
  return request(url, "post", data, headers);
}

const api = {
  apiUrl: process.env.VUE_APP_BASH_URL,
  imageUrl: process.env.VUE_APP_BASH_IMAGE_URL,
  videoUrl: process.env.VUE_APP_BASH_VIDEO_URL,
  formatApiUrl(url) {
    if (!url) return null;
    const bashUrl = this.apiUrl;
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      return url;
    }
    if (url.indexOf("/") === 0) {
      return bashUrl + url.slice(1);
    }
    return bashUrl + url;
  },
  formatImageUrl(url) {
    if (!url) return null;
    const bashImageUrl = this.imageUrl;
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      return url;
    }
    if (url.indexOf("/") === 0) {
      return bashImageUrl + url.slice(1);
    }
    return bashImageUrl + url;
  },
  formatVideoUrl(url) {
    if (!url) return null;
    const bashVideoUrl = this.videoUrl;
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      return url;
    }
    if (url.indexOf("/") === 0) {
      return bashVideoUrl + url.slice(1);
    }
    return bashVideoUrl + url;
  },
  search: {
    // 加载搜索推荐关键词
    loadSearchKeyWords: data => {
      return post("api/C_Search/LoadSearchKeyWords", data);
    },
    // 根据传入搜索关键字加载分页产品
    loadSearchProductByPage: data => {
      return post("api/C_Search/LoadSearchProductByPage", data);
    }
  },
  index: {
    // 全部商品
    loadCProductByPage: data => {
      return post("api/C_Index/LoadCProductByPage", data);
    },
    // 首页数据
    loadAppIndex: data => {
      return post("api/C_Index/C_LoadAppIndex", data);
    },
    // 获取热门
    loadSpecialProduct: data => {
      return post("api/C_Index/C_LoadSpecialProduct", data);
    },
    // 获取全部分类
    loadProductClass: data => {
      return post("api/C_Product/LoadProductClass", data);
    }
  },
  countData: {
    productCilick: data => {
      return post("api/SU_CountData/CountData_ProductCilick", data);
    }
  },
  customer: {
    editCustomerFreightModel: data => {
      return post("api/SU_Customer/EditCustomerFreightModel", data);
    },
    loadCustomerFreightModel: _ => {
      return post("api/SU_Customer/LoadCustomerFreightModel");
    },
    deleteCustomerFreightModel: data => {
      return post("api/SU_Customer/DeleteCustomerFreightModel", data);
    },
    loadCustomerFreightModelDetails: data => {
      return post("api/SU_Customer/LoadCustomerFreightModelDetails", data);
    },
    editCustomerHeadPhoto: data => {
      return post("api/SU_Customer/EditCustomerHeadPhoto", data);
    },
    loadCustomerInfo: data => {
      return post("api/SU_Customer/LoadCustomerInfo", data);
    },
    editCutomerInfo: data => {
      return post("api/SU_Customer/EditCutomerInfo", data);
    },
    switchSupplierMode: data => {
      return post("api/SU_Customer/SwitchSupplierMode ", data);
    },
    getSupplierStoreDisplaySetting: data => {
      return post("api/SU_Customer/GetSupplierStoreDisplaySetting ", data);
    },
    saveSpplierStoreDisplaySetting: data => {
      return post("api/SU_Customer/SaveSpplierStoreDisplaySetting ", data);
    },
    getSupplierShopHomePage: data => {
      return post("api/SU_Customer/GetSupplierShopHomePage", data);
    },
    getAdvertList: data => {
      return post("api/SU_Customer/GetAdvertList", data);
    },
    deleteAdvertInfo: data => {
      return post("api/SU_Customer/DeleteAdvertInfo", data);
    },
    saveAdvertInfo: data => {
      return post("api/SU_Customer/SaveAdvertInfo", data);
    },
    editAdvertState: data => {
      return post("api/SU_Customer/EditAdvertState", data);
    },
    loadHomeIndex: data => {
      return post("api/SU_Customer/LoadHomeIndex", data);
    },
    getTopProductAndClassInfo: data => {
      return post("api/SU_Customer/GetTopProductAndClassInfo", data);
    },
    loadContactSupplier: data => {
      return post("api/SU_Customer/LoadContactSupplier", data);
    },
    getCountryInfoList: data => {
      return post("api/SU_Customer/GetCountryInfoList", data);
    },
    getProvinceInfoList: data => {
      return post("api/SU_Customer/GetProvinceInfoList", data);
    },
    getCityInfoList: data => {
      return post("api/SU_Customer/GetCityInfoList", data);
    },
    addContactSupplier: data => {
      return post("api/SU_Customer/AddContactSupplier", data);
    },
    addProblemFeedbackInfo: data => {
      return post("api/SU_Customer/AddProblemFeedbackInfo", data);
    }
  },
  login: {
    userLogin: data => {
      // 登录操作
      return post("api/SU_Login/UserLogin", data);
    },
    registerUser: data => {
      // 注册账户 注册第一步
      return post("api/SU_Login/RegisterUser", data);
    },
    // 修改密码
    changeUserPassword: data => {
      return post("api/SU_Login/ChangeUserPassword", data);
    },
    registerCustomerCheckInfo: data => {
      return post("api/SU_Login/RegisterCustomerCheckInfo", data);
    },
    // 检查号码是否重复
    checkRepeatPhoneNumber: data => {
      return post("api/SU_Login/GetPhoneNumberVerification", data);
    }
  },
  shopCar: {
    // 分页获取用户购物车信息（已实现
    loadShopCarByPage: data => {
      return post("api/C_ShopCar/LoadShopCarByPage", data);
    },
    // 添加产品到用户的购物车（已实现
    addShopCar: data => {
      return post("api/C_ShopCar/AddShopCar", data);
    },
    // 根据传入的购物车编号删除购物车内数据（已实现
    deleteShopCar: data => {
      return post("api/C_ShopCar/DeleteShopCar", data);
    },
    // 批量删除购物车（已实现）
    deleteShopCarByList: data => {
      return post("api/C_ShopCar/DeleteShopCarByList", data);
    }
  },
  clogin: {
    // 用户登录
    userLogin: data => {
      return post("api/C_Login/C_UserLogin", data);
    },
    // 注册
    registerUser: data => {
      return post("api/C_Login/C_RegisterUser", data);
    },
    // 退出登录
    loginOut: data => {
      return get("api/C_Login/LoginOut", data);
    },
    // 验证账号是否注册
    checkRegisterUser: data => {
      return post("api/C_Login/CheckRegisterUser", data);
    },
    // 当旧密码没有发送时会当做忘记密码直接修改密码，发送了旧密码会验证旧密码再修改密码 ,如果只发送新密码需要搭配验证码一起发送
    changeUserPassword: data => {
      return post("api/C_Login/C_ChangeUserPassword", data);
    },
    // 获取用户信息
    getUserInfo: data => {
      return post("api/C_Users/C_GetUserInfo", data);
    },
    // 上传图片（已实现）
    uploadImgFile: data => {
      return post("api/C_System/C_UploadImgFile", data);
    },
    // 修改用户信息
    editUserInfo: data => {
      return post("api/C_Users/C_EditUserInfo", data);
    }
  },
  cOrder: {
    loadOrderByPage: data => {
      return post("api/C_Order/C_LoadOrderByPage", data);
    },
    loadOrderPreview: data => {
      return post("api/C_Order/C_LoadOrderPreview", data);
    },
    orderPreviewByCroPay: data => {
      return post("api/C_Order/C_AddOrderPreviewByCroPay", data);
    },
    channelDealerListByPaymentWay: data => {
      return post("api/C_Order/C_ChannelDealerListByPaymentWay", data);
    },
    generatePaymentLinks: data => {
      return post("api/C_Order/" + data.PaymentLink, data);
    },
    cancelOrder: data => {
      return post("api/C_Order/CancelOrder", data);
    },
    loadOrderLogistics: data => {
      return post("api/C_Order/C_LoadOrderLogistics", data);
    },
    getVanCheenBankAccountInfo: data => {
      return post("api/C_Order/GetVanCheenBankAccountInfo", data);
    },
    addOrderLinePaymentRecord: data => {
      return post("api/C_Order/AddOrderLinePaymentRecord", data);
    },
    getOrderLinePaymentRecord: data => {
      return post("api/C_Order/GetOrderLinePaymentRecord", data);
    },
    confirmReceipt: data => {
      return post("api/C_Order/ConfirmReceipt", data);
    },
    loadOrderInfo: data => {
      return post("api/C_Order/C_LoadOrderInfo", data);
    },
  },
  cUser: {
    loadUsersReceiving: data => {
      return post("api/C_Users/LoadUsersReceiving", data);
    },
    loadUsersReceivingInfo: data => {
      return post("api/C_Users/LoadUsersReceivingInfo", data);
    },
    deleteUsersReceiving: data => {
      return post("api/C_Users/DeleteUsersReceiving", data);
    },
    getCountrys: data => {
      return get("api/C_System/GetCountrys", data);
    },
    addUsersReceiving: data => {
      return post("api/C_Users/AddUsersReceiving", data);
    },
  },
  cFollow: {
    // 我喜爱的产品分页列表
    favoriteProductByPage: data => {
      return post("api/C_Follow/C_FavoriteProductByPage", data);
    },
    // 关注供应商分页列表
    followShopByPage: data => {
      return post("api/C_Follow/C_FollowShopByPage", data);
    },
    // 关注、取消关注 店铺（已完成)
    addFollowShop: data => {
      return post("api/C_Follow/C_AddFollowShop", data);
    },
    // 添加/取消添加 产品到我喜爱（Token）
    addFavoriteProduct: data => {
      return post("api/C_Follow/C_AddFavoriteProduct", data);
    },
    // 我的足迹
    footmarkByPage: data => {
      return post("api/C_Follow/C_FootmarkByPage", data);
    }
  },
  cProduct: {
    // C端获取商品详情信息（已实现）
    loadProductInfo: data => {
      return post("api/C_Product/C_LoadProductInfo", data);
    },
    recommendProduct: data => {
      return post("api/C_Product/RecommendProduct", data);
    }
  },
  cShop: {
    // 获取店铺信息
    loadShopInfo: headers => {
      return post("api/C_Shop/LoadShopInfo", {}, headers);
    },
    // 加载店铺（包含热销产品，全部产品
    loadShop: data => {
      return post("api/C_Shop/LoadShop", data);
    },
    // 加载店铺产品（分页
    loadShopProductByPage: data => {
      return post("api/C_Shop/LoadShopProductByPage", data);
    },

    //获取认证信息
    loadShopCheckInfo: data => {
      return post("api/B_Shop/LoadShopCheckInfo", data);
    },
    //注册店铺
    registerShopCheckInfo: data => {
      return post("api/B_Login/RegisterShopCheckInfo", data);
    },
    // 上传图片
    uploadImgFile: (file, headers, onUploadProgress) => {
      let type = file.type;
      let data = new FormData();
      data.append("file", file, file.name);
      let _headers = headers;
      _headers["Content-Type"] = type;
      _headers[
        "Content-Disposition"
      ] = `form-data; name="pc"; filename="${encodeURI(file.name)}"`;
      return axios({
        url: "api/B_System/UploadImgFile",
        method: "post",
        headers: _headers,
        data,
        onUploadProgress
      });
    }
  },
  order: {
    loadOrderByPage: data => {
      return post("api/SU_Order/LoadOrderByPage", data);
    },
    editOrderPostNumber: data => {
      return post("api/SU_Order/EditOrderPostNumber", data);
    },
    createExpressLabel: data => {
      return post("api/SU_Order/CreateExpressLabel", data);
    },
    loadOrderInfo: data => {
      return post("api/SU_Order/LoadOrderInfo", data);
    },
    loadOrderLogistics: data => {
      return post("api/SU_Order/SU_LoadOrderLogistics", data);
    },
    cancelOrder: data => {
      return post("api/SU_Order/SU_CancelOrder", data);
    },
    batchEditOrderPostNumber: data => {
      return post("api/SU_Order/BatchEditOrderPostNumber", data);
    }
  },
  product: {
    // 分类列表
    loadProductClass: data => {
      return post("api/SU_Product/LoadProductClass", data);
    },
    loadProductClassModels: data => {
      return post("api/SU_Product/LoadProductClassModels", data);
    },
    loadProductByTBId: data => {
      return post("api/SU_Product/LoadProductByTBId", data);
    },
    getProductsClassBySelect: data => {
      return post("api/SU_Product/GetProductsClassBySelect", data);
    },
    loadAddProductData: data => {
      return post("api/SU_Product/LoadAddProductData", data);
    },
    addProducts: data => {
      return post("api/SU_Product/AddProducts", data);
    },
    loadProductsByPage: data => {
      return post("api/SU_Product/LoadProductsByPage", data);
    },
    deleteListProduct: data => {
      return post("api/SU_Product/DeleteListProduct", data);
    },
    deleteProduct: data => {
      return post("api/SU_Product/DeleteProduct", data);
    },
    editListProductStatus: data => {
      return post("api/SU_Product/EditListProductStatus", data);
    },
    editProductStatus: data => {
      return post("api/SU_Product/EditProductStatus", data);
    },
    getProductsByNumber: data => {
      return post("api/SU_Product/GetProductsByNumber", data);
    },
    loadTBAddProductData: data => {
      return post("api/SU_Product/LoadTBAddProductData", data);
    },
    releaseProductsIndex: data => {
      return post("api/SU_Product/ReleaseProductsIndex", data);
    },
    getBusinessProductClassList: data => {
      return post("api/SU_Product/GetBusinessProductClassList", data);
    },
    saveSupplierProductInfo: data => {
      return post("api/SU_Product/SaveSupplierProductInfo", data);
    },
    getSupplierProductInfo: data => {
      return post("api/SU_Product/GetSupplierProductInfo", data);
    },
    deleteSupplierProductInfo: data => {
      return post("api/SU_Product/DeleteSupplierProductInfo", data);
    },
    setShopShowcaseProduct: data => {
      return post("api/SU_Product/SetShopShowcaseProduct", data);
    },
    setProductState: data => {
      return post("api/SU_Product/SetProductState", data);
    },
    getProductSearchList: data => {
      return post("api/SU_Product/GetProductSearchList", data);
    },
    updateProductParentClassIcon: data => {
      return post("api/SU_Product/UpdateProductParentClassIcon", data);
    },
    getAttestationTypeList: (data) => {
      return post("api/SU_Product/GetAttestationTypeList", data);
    },
  },
  cSystem: {
    // 通用发送邮件验证码
    sendEmailCode: data => {
      return post("api/C_System/SendEmailCode", data);
    },
    // 验证邮箱验证码是否正确
    checkEmailCode: data => {
      return post("api/C_System/CheckEmailCode", data);
    }
  },
  system: {
    //获取平台消息列表
    messageList: data => {
      return post("api/C_System/GetPlatformMessageContentList", data);
    },
    // 发送验证码
    sendAuthCode: data => {
      return post("api/SU_System/SendAuthCode", data);
    },
    // 短信验证是否正确
    checkAuthCode: data => {
      return post("api/SU_System/CheckAuthCode", data);
    },
    // 获取平台公告内容
    getPlatformMessage: data => {
      return post("api/C_System/GetPlatformMessageContentList", data);
    },
    // 获取平台消息公告详情
    getPlatformMessageDetail: data => {
      return post("api/C_System/GetPlatformMessageContentInfo", data);
    },
    // 获取平台公告未读数量
    getPlatformMessageCount: data => {
      return post("api/C_System/GetUserUnreadMessageCount", data);
    },
    // 获取服务类型列表
    getServiceTypeList: data => {
      return post("api/C_System/GetServiceTypeList", data);
    },
    // 添加问题反馈
    addProblemFeedback: data => {
      return post("api/C_System/AddProblemFeedback", data);
    },
    // 获取问题反馈列表
    getProblemFeedbackByPage: data => {
      return post("api/C_System/LoadProblemFeedbackByPage", data);
    },
    // 获取问题详情
    getProblemFeedbackInfo: data => {
      return post("api/C_System/LoadProblemFeedbackInfo", data);
    },
    // 添加问题回复
    addProblemReply: data => {
      return post("api/C_System/AddProblemReply", data);
    },
    uploadImgFile: (file, headers, onUploadProgress) => {
      let type = file.type;
      let data = new FormData();
      data.append("file", file, file.name);
      let _headers = headers;
      _headers["Content-Type"] = type;
      _headers[
        "Content-Disposition"
      ] = `form-data; name="pc"; filename="${encodeURI(file.name)}"`;
      return axios({
        url: "api/SU_System/UploadImgFile",
        method: "post",
        headers: _headers,
        data,
        onUploadProgress
      });
    },
    uploadVideoFile: (file, headers, onUploadProgress) => {
      let type = file.type;
      let data = new FormData();
      data.append("file", file, file.name);
      let _headers = headers;
      _headers["Content-Type"] = type;
      _headers[
        "Content-Disposition"
      ] = `form-data; name="pc"; filename="${encodeURI(file.name)}"`;
      return axios({
        url: "api/SU_System/UploadVideoFile",
        method: "post",
        headers: _headers,
        data,
        onUploadProgress
      });
    },
    getProvinces: _ => {
      return get("api/SU_System/GetProvinces");
    },
    getCities: provinceID => {
      return get(`api/SU_System/GetCitys/${provinceID}`);
    },
    getAreas: cityID => {
      return get(`api/SU_System/GetArea/${cityID}`);
    },
    getCountrys: _ => {
      return get("api/SU_System/GetCountrys");
    }
  },
  user: {
    loadUserInfo: headers => {
      return post("api/SU_User/LoadUserInfo", {}, headers);
    },
    editUserPhone: data => {
      return post("api/SU_User/EditUserPhone", data);
    }
    // loginuser: headers => {
    //   return post('api/SU_User/LoadUserInfo', {}, headers)
    // }
  },
  coupon: {
    //获取用户优惠券列表
    getUserCouponListByPage: data => {
      return post("api/C_Users/GetUserCouponListByPage", data);
    },
  },
  // 财务获
  finance: {
    // 取财务信息
    loadFinanceByPage: data => {
      return post("api/SU_Finance/LoadFinanceByPage", data);
    },
    // 取财务信息
    checkUse: data => {
      return post("api/SU_Finance/CheckUse", data);
    },
    // 申请提现
    applyWithdraw: data => {
      return post("api/SU_Customer/AddCustomerWithdraw", data);
    },
    //获取用户可提现订单列表
    getUserWithdrawOrderList: data => {
      return post("api/SU_Customer/GetUserWithdrawOrderList", data);
    }
  },
  admin: {
    userLogin: data => {
      return post("api/Adm_Login/UserLogin", data);
    },
  }
};

export default api;
